var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKashpo = function SvgKashpo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "M35.743 49.031C48.043 49.023 58 39.056 58 26.745c0-5.41-1.924-10.369-5.126-14.23H18.595C15.393 16.377 13.5 20.59 13.5 26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "M2 25h38l-5.288 27.973L7.477 53 2 25Z"
  })));
};
export default SvgKashpo;